export enum PageName {
  Home = 'Airline Tickets, Flights & Airfare: Book Direct - Official Site | JetBlue',
  signin = 'JetBlue | SignIn',
  flighttracker = 'JetBlue | Flight Tracker',
  flightsdestination = 'JetBlue | Flights Destination',
  NoResultPage = 'JetBlue | No Results',
}
